<template>
    <div class="periodicOrder">
        <headers :title="'定期保洁预约'"/>
        <!-- 地址栏 -->
          <div class="addressOut" @click="changeAddress">
                 <div class="addressContent">
                     <div class="namePhone">
                         <div class="name">{{Address.guestName}}</div>
                         <div class="phone">{{Address.guestPhone}}</div>
                         <div class="acreage" v-if="Address.Acreage">{{Address.Acreage}}㎡</div>
                     </div>
                     <div class="address">
                        {{Address.guestAddress}}
                     </div>
                 </div>
                 <div class="addressRight">
                     <span class="iconfont iconyoujiantou"></span>
                 </div>
          </div>
        <!-- 选择按钮 -->
             <div class="select">
               <div class="selectOut" v-for="(item,index) in PriceArr" :key="index">
                   <div class="select-one" :class="{on:index == showButtonIndex}" @click="selectButton(index)" ><p>{{item.ItemName}}</p><p>{{item.ItemPrice}}{{item.ItemUnit}}</p></div>
               </div>  
             </div>
          <!-- 建议时长 -->
        <div class="orderImg">
            <img :src="ServiceFlowPicture.Url" alt="">
        </div>
        <!-- 信息 -->
         <div class="information">
             <span style="font-size: 14px;color: #000">定期保洁：</span>以周为单位，每周固定时间到同一地址提供保洁服务，付款方式可选次结或者月结
         </div>

        <!-- 选择每周的服务时间 -->
         <div class="week">
             <p class="weekTitle">选择每周服务时间<span style="color: red">（周期默认为4周）</span></p>
             <div class="weekButton">
                 <div><div class="buttonItem" :class="dayArr[0].status?'on':''" @click="ClickSelect(0)">星期一</div></div>
                 <div><div class="buttonItem" :class="dayArr[1].status?'on':''" @click="ClickSelect(1)">星期二</div></div>
                 <div><div class="buttonItem" :class="dayArr[2].status?'on':''" @click="ClickSelect(2)">星期三</div></div>
                 <div><div class="buttonItem" :class="dayArr[3].status?'on':''" @click="ClickSelect(3)">星期四</div></div>
                 <div><div class="buttonItem" :class="dayArr[4].status?'on':''" @click="ClickSelect(4)">星期五</div></div>
                 <div><div class="buttonItem" :class="dayArr[5].status?'on':''" @click="ClickSelect(5)">星期六</div></div>
                 <div><div class="buttonItem" :class="dayArr[6].status?'on':''" @click="ClickSelect(6)">星期日</div></div>
             </div>
         </div>

         <!-- 已经选择的服务时间 -->
         <div class="serviceTable">
           <p class="serviceTableTitle">你已选择的每周服务时间</p>
           <div class="timeTable">
                    <div class="tableTitle">
                        <div>日期</div>
                        <div>开始时间</div>
                        <div>结束时间</div>
                        <div>时长</div>
                    </div>
                    <div class="tableContent" v-if="dayArr[0].status">
                        <div>星期一</div>
                        <div>{{dayArr[0].startTime}}</div>
                        <div>{{dayArr[0].endTime}}</div>
                        <div>{{dayArr[0].duration}}小时</div>
                    </div>
                    <div class="tableContent" v-if="dayArr[1].status">
                        <div>星期二</div>
                        <div>{{dayArr[1].startTime}}</div>
                        <div>{{dayArr[1].endTime}}</div>
                        <div>{{dayArr[1].duration}}小时</div>
                    </div>
                    <div class="tableContent" v-if="dayArr[2].status">
                        <div>星期三</div>
                        <div>{{dayArr[2].startTime}}</div>
                        <div>{{dayArr[2].endTime}}</div>
                        <div>{{dayArr[2].duration}}小时</div>
                    </div>
                    <div class="tableContent" v-if="dayArr[3].status">
                        <div>星期四</div>
                        <div>{{dayArr[3].startTime}}</div>
                        <div>{{dayArr[3].endTime}}</div>
                        <div>{{dayArr[3].duration}}小时</div>
                    </div>
                    <div class="tableContent" v-if="dayArr[4].status">
                        <div>星期五</div>
                        <div>{{dayArr[4].startTime}}</div>
                        <div>{{dayArr[4].endTime}}</div>
                        <div>{{dayArr[4].duration}}小时</div>
                    </div>
                    <div class="tableContent" v-if="dayArr[5].status">
                        <div>星期六</div>
                        <div>{{dayArr[5].startTime}}</div>
                        <div>{{dayArr[5].endTime}}</div>
                        <div>{{dayArr[5].duration}}小时</div>
                    </div>
                    <div class="tableContent" v-if="dayArr[6].status">
                        <div>星期日</div>
                        <div>{{dayArr[6].startTime}}</div>
                        <div>{{dayArr[6].endTime}}</div>
                        <div>{{dayArr[6].duration}}小时</div>
                    </div>
            </div>
         </div>
        <!-- 选择第一次服务时间 -->
          <div class="firsttime">
              <p class="firsttimeText">选择第一次服务时间</p>
              <div class="firsttimeButton" :class="firstServiceTime?'on':''" @click="ServiceTime">{{firstServiceTime?firstServiceTime:'请选择第一次服务时间'}}</div>
          </div>
        <!-- 备注 -->
        <van-cell-group class="message">
            <van-field
                v-model="message"
                label="备注"
                type="textarea"
                placeholder="请输入留言"
                rows="1"
                autosize
            />
        </van-cell-group>
        <!-- 空元素 -->
        <div class="nothing"></div>
        <!-- 脚步导航 -->
        <div class="foot">
          <div class="kf"><a href="tel:4001500600">客服</a></div>
          <div class="confirm"  @click="confirmOrder">修改订单</div>
        </div>
        <!-- 点击每周的选择器 -->
        <van-popup v-model="isShowPickerOne" position="bottom" :overlay="true">
                  <van-picker :columns="columnsOne" show-toolbar title="请选择每周服务时间" @cancel="onCancelOne" @confirm="onConfirmOne" v-if="isShowPickerOne"/>
         </van-popup>
         <!-- 第一次服务的选择器 -->
        <van-popup v-model="isShowPickerTwo" position="bottom" :overlay="true">
                  <van-picker :columns="columnsTwo" show-toolbar title="请选择第一次服务时间" @cancel="onCancelTwo" @confirm="onConfirmTwo" v-if="isShowPickerTwo"/>
         </van-popup>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import dayjs from 'dayjs'
import { Toast } from 'vant'
export default {
    data () {
        return {
            message: '',
            showButtonIndex: 0,
            isShowPickerOne: false,
            isShowPickerTwo: false,
            dayArr: [
                 {label:'星期一',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期二',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期三',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期四',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期五',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期六',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期日',status:false,duration:0,startTime:'',endTime:''}
            ],
            dayIndex: null, // 日期下标
            columnsOne: [
                {
                values:["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30","19:00"],
                defaultIndex:0
                },
                {
                values: ["10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30","19:00","19:30","20:00","20:30","21:00","21:30","22:00"],
                defaultIndex:0
                }
            ],
            columnsTwo: [{values:[]}],
            firstServiceTime:'',
            ServiceFlowPicture: {},
            PriceArr:[],
            PriceOne:{},
            PriceTwo:{},
            Address:{},
            ServicePrice:null, //单价
            ContentId: null,
            ServiceId: null,
            ContentType: '',
            FirstServiceDate: '', //首次服务日期
            FirstServiceDateWeek: '', //首次服务星期
            OrderId: null,
            isConfirmOrder: false,
        }
    },
    computed:{
     ...mapState(['orderAddress']),

    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'AddressList') { //判断是从哪个路由过来的
          to.meta.isBack = true;
      }
      next();
    },
    created () {
      // this.getData()
    },
     mounted(){
       this.getData() 
    },
     /* activated(){
          if (this.orderAddress.length > 0) {
             this.Address = this.orderAddress[0]
          }  
          if(!this.$route.meta.isBack) {  // 不是后退，重新拿数据
             this.showButtonIndex = 0
             this.dayArr = [
                 {label:'星期一',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期二',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期三',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期四',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期五',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期六',status:false,duration:0,startTime:'',endTime:''},
                 {label:'星期日',status:false,duration:0,startTime:'',endTime:''}
            ]
             this.firstServiceTime = ''
             this.FirstServiceDate = ''
             this.FirstServiceDateWeek = ''
             this.message = ''
             this.columnsTwo = [{values:[]}]
             this.getData()
             
            }
            this.$route.meta.isBack = false
    }, */
    methods: {
        getData () {
           // 发送请求
      
           // 获取订单信息
          this.$axios.get('/api/DjOrder/GetOrderInfo',{
                params: {
                  Id: this.$route.query.Id
                }
            }).then(res => {
              let data = res.data
              let ContentInfoData = data.ContentInfo
              if (process.env.NODE_ENV === "development"){
                this.ServiceFlowPicture = JSON.parse(ContentInfoData.Pictures).ServiceFlowPicture.map((i) => {
                  i.Url = 'http://www.lungchuenjz.cn' + i.Url
                  return i
                })[0]
              }else{
                this.ServiceFlowPicture = JSON.parse(ContentInfoData.Pictures).ServiceFlowPicture[0]
              }
            

            this.PriceArr = JSON.parse(ContentInfoData.PriceJson)
            //this.PriceOne = JSON.parse(ContentInfoData.PriceJson)[0]
            //this.PriceTwo = JSON.parse(ContentInfoData.PriceJson)[1]

            this.ServicePrice = Number(this.PriceArr[0].ItemPrice)
            this.ContentId = ContentInfoData.ContentId
            this.ServiceId = ContentInfoData.ServiceId
            this.ContentType = ContentInfoData.ContentType

            // OrderId
              this.OrderId = data.OrderId
              
               // 地址信息
              this.Address.guestName = data.CustomerName
              this.Address.guestPhone = data.CustomerPhone
              this.Address.guestAddress = data.CustomerAddress
              this.Address.address0 = data.Add0
              this.Address.address1 = data.Add1
              this.Address.address2 = data.Add2
              this.Address.Acreage = data.Acreage
               // 备注
               this.message = data.CustomerRemarks
               // 规则
               let ServiceRule = JSON.parse(data.ServiceRule)
                this.ServicePrice = ServiceRule.ServicePrice
               console.log(ServiceRule)
               this.PriceArr.forEach((item,index) => {
                 if (ServiceRule.ServicePrice == item.ItemPrice) {
                       this.showButtonIndex = index
                 }
               })
               let ListWeekTime = ServiceRule.ListWeekTime

               ListWeekTime.forEach(i => {
                 this.dayArr.forEach(j => {
                   if (j.label == i.Week) {
                      j.status = true
                      j.startTime = i.WeekTime
                      j.endTime = i.WeekTimeEnd
                      j.duration = i.TimeLong
                   }
                 })
               })
               this.FirstServiceDate = ServiceRule.FirstServiceDate.split(" ")[0]
               this.FirstServiceDateWeek = ServiceRule.FirstServiceDateWeek
               this.firstServiceTime = this.FirstServiceDate+" "+this.FirstServiceDateWeek
               
               if (this.$route.meta.isBack){ // 选地址后 后退的数据
                  if (this.orderAddress.length > 0) {
                    this.Address = this.orderAddress[0]
                  } 
                  let periodicObj = JSON.parse(localStorage.getItem('periodicEditObj'))
                  this.message = periodicObj.message
                  this.ServicePrice = periodicObj.ServicePrice
                  this.dayArr = periodicObj.dayArr
                  this.firstServiceTime = periodicObj.firstServiceTime
                  this.FirstServiceDate = periodicObj.FirstServiceDate
                  this.FirstServiceDateWeek = periodicObj.FirstServiceDateWeek
                  this.PriceArr.forEach((item,index) => {
                        if (item.ItemPrice == this.ServicePrice) {
                              this.showButtonIndex = index
                        }
                  })
                    localStorage.removeItem('periodicEditObj')
              }

            })
       


        },
        selectButton (index) {
         this.showButtonIndex = index
          let price = Number(this.PriceArr[index].ItemPrice)
          this.ServicePrice = price
         
        },
      
        ClickSelect (index) {
        
            if (this.dayArr[index].status) {
                 this.dayArr[index].status = false 
                 this.dayArr[index].duration = 0
                 this.dayArr[index].startTime = ''
                 this.dayArr[index].endTime = ''
                  // 判断是不是最后一个
                  let flag = 0
                  this.dayArr.forEach(i => {
                      if (i.status) {
                        flag++
                      }
                  })
                  if (flag == 0) {
                       this.firstServiceTime = ''
                       this.FirstServiceDate = ''
                       this.FirstServiceDateWeek = ''
                  }
                  if (this.dayArr[index].label == this.FirstServiceDateWeek) {
                    this.firstServiceTime = ''
                    this.FirstServiceDate = ''
                    this.FirstServiceDateWeek = ''
                  }



            }else{
              this.isShowPickerOne = true
              this.dayIndex = index
            }
          
        },
        onCancelOne() {
           this.isShowPickerOne = false
        },
        onConfirmOne (value, index) {
            
                let startTime = value[0]
                let endTime = value[1]
                const nData = new Date()
                const year = nData.getFullYear()
                const month = nData.getMonth() + 1
                const day = nData.getDay()
                const nStartTime = year + '-' + month + '-' + day + ' ' + startTime
                const nEbdTime = year + '-' + month + '-' + day + ' ' + endTime
                const date1 = dayjs(nStartTime)
                const date2 = dayjs(nEbdTime)
                
                let difference = date2.diff(date1, 'hours',true)
                  
                  if (difference < 3) {
                      Toast('开始与结束时间间隔最少3小时');
                  }else{
                      this.dayArr[this.dayIndex].startTime = startTime
                      this.dayArr[this.dayIndex].endTime = endTime
                      this.dayArr[this.dayIndex].duration = difference
                      this.dayArr[this.dayIndex].status = true
                      this.isShowPickerOne = false
                  }
            
            

        },
        ServiceTime () {
            let flag = 0
            this.dayArr.forEach(i => {
                if (i.status) {
                  flag++
                }
            })
            if (flag == 0) {
               Toast('请选择每周服务时间！');
            }else{
                // 发送请求
                let newArr = []
                  this.dayArr.forEach(i => {
                    if (i.status) {
                       newArr.push({Week:i.label})
                    }
                })
                // 发送异步请求
                this.$axios.get('/api/DjOrder/GetWeekCanUseDate',{ params: {
                        ListWeekTime: JSON.stringify(newArr)
                    }}).then(res => {
                        this.columnsTwo = [{values:[]}]
                        res.data.forEach(i => {
                            this.columnsTwo[0].values.push(i.Date+' '+i.Week)
                        })
                    
                         // 显示选择器
                          this.isShowPickerTwo = true
                    })
                
                

            }
        },
        onCancelTwo () {
            this.isShowPickerTwo = false
        },
        onConfirmTwo (value, index) {
            this.firstServiceTime = value[0]
            this.isShowPickerTwo = false
            this.FirstServiceDate = (value[0].split(" "))[0]
            this.FirstServiceDateWeek = (value[0].split(" "))[1]
            
        },
        changeAddress () {
          let _this = this
          let periodicObj = {
             message:_this.message,
             ServicePrice:_this.ServicePrice,
             dayArr:_this.dayArr,
             firstServiceTime:_this.firstServiceTime,
             FirstServiceDate:_this.FirstServiceDate,
             FirstServiceDateWeek:_this.FirstServiceDateWeek
          }
          localStorage.setItem('periodicEditObj', JSON.stringify(periodicObj))
          this.$router.push('/addresslist')
        },
        confirmOrder () {

          if (!this.Address) {
            Toast('请输入有效地址信息！');
            return
            }
            
          if (this.firstServiceTime == '') {
             Toast('请选择服务日期！');
          }else {
              let ListWeekTime = []
              this.dayArr.forEach(i => {
                if (i.status) {
                    let ListWeekTimeItem = {}
                    ListWeekTimeItem.Week = i.label
                    ListWeekTimeItem.WeekTime = i.startTime
                    ListWeekTimeItem.WeekTimeEnd = i.endTime
                    ListWeekTimeItem.TimeLong = i.duration
                    ListWeekTime.push(ListWeekTimeItem)
                    
                }
              })
              let ServiceRule = JSON.stringify({
              ServicePrice: this.ServicePrice,
              ListWeekTime: ListWeekTime,
              FirstServiceDate: this.FirstServiceDate,
              FirstServiceDateWeek: this.FirstServiceDateWeek,
              CustomerRemarks: this.message
            })

            if(!this.isConfirmOrder){
              this.isConfirmOrder = true

               this.$axios.post('/api/DjOrder/EditOrder',{
              OrderId: this.OrderId,
              CustomerName: this.Address.guestName,
              CustomerPhone: this.Address.guestPhone,
              CustomerAddress: this.Address.guestAddress,
              Add0: this.Address.address0,
              Add1: this.Address.address1,
              Add2: this.Address.address2,
              Acreage: this.Address.Acreage,
              CustomerRemarks: this.message,
              OrderFlag: this.ContentType,
              ContentId: this.ContentId,
              ServiceId: this.ServiceId,
              ServicePrice: this.ServicePrice,
              ServiceUnit: this.PriceArr[0].ItemUnit,
              ServiceRule
            }).then(res => {
              // console.log(res)
              if (res.data.type == 1 ) { 
                Toast.success({
                  message: '成功修改订单',
                  duration: 500
                })
                this.isConfirmOrder = false
                this.$router.push('/orderlist')
               }else{
                 this.isConfirmOrder = false
                 Toast(res.data.message);
               }
            }).catch(() => {
              this.isConfirmOrder = false
              Toast('提交失败，请重新提交！');
            })
            }
           



          }
        }
    }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.periodicOrder
  background: rgb(240, 240, 240)
  height: 100vh
  .addressOut
    width: 100%
    height: 80px
    margin-top: 45px
    background: #f7f4e4
    position: relative
    display: flex
    justify-content: center
    align-items: center
    font-size: 14px
    color: #6b6b6b
    &::before
     content:''
     position:absolute
     top:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")   
    &::after
     content:''
     position:absolute
     bottom:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")
    .addressContent
      height: 100%
      width: 90%
      margin-left: -2px
      display: flex
      flex-direction: column
      justify-content: center
      padding: 5px
      .namePhone
        display: flex
        margin-bottom: 12px
        .name
          margin-right: 12px
        .phone
          margin-right: 64px
    .addressRight
      &>span
        font-size: 28px
  .select
    width: 100%
    background:white
    margin-top: 10px
    display: flex
    flex-wrap: wrap
    justify-content: center
    align-items: center
    padding: 18px 12px
    box-sizing: border-box
    .selectOut
      width: 50%
      margin-bottom: 6px
      .select-one
        padding: 2px
        box-sizing: border-box
        height: 46px
        width: 90%
        border: 1px solid #eee
        display: flex
        font-size: 14px
        flex-direction: column
        justify-content: center
        align-items: center
        border-radius: 8px
        margin: auto
        position: relative
        overflow: hidden
        &.on
          border: 1px solid green
          color: green
          &::after
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            right: 0px;
            bottom: 0px;
            border-bottom: 18px solid #009933;
            border-left: 18px solid transparent;
  .orderImg
    width: 100%
    border-top: 1px solid #eee
    background: white
    &>img
     width: 100%
  .information
    width: 100%
    margin: 0px auto 8px
    letter-spacing: 2px
    line-height: 20px
    background: white
    font-size: 12px
    color: #6b6b6b
    padding: 8px
    box-sizing: border-box
  .week
    width: 100%
    height: 120px
    margin-bottom: 6px
    background: white
    padding-bottom: 8px
    .weekTitle
      padding-left: 6px
      padding-top: 6px
      font-size: 14px
    .weekButton
      display: flex
      flex-wrap: wrap
      height: 90%
      &>div
       width: 25%
       display: flex
       justify-content: center
       align-items: center
       .buttonItem
         height: 60%
         width: 80%
         border: 1px solid #bfbfbf
         border-radius: 6px
         display: flex
         justify-content: center
         align-items: center
         font-size: 14px
         &.on
          background: #009933
          color: white
  .serviceTable
    width: 100%
    background: white
    .serviceTableTitle
      padding-left: 6px
      padding-top: 6px
      font-size: 14px
    .timeTable
       width: 98%
       margin: 5px auto
       display: flex
       flex-direction: column
       background: white
       padding-bottom: 6px
       font-size: 14px
       .tableTitle
         display: flex
         &>div
          width: 25%
          display: flex
          justify-content: center
          align-items: center
          border: 1px solid #bfbfbf
          border-right: none
          height: 30px
          &:last-child
           border-right: 1px solid #bfbfbf
       .tableContent
         display: flex
         &>div
          width: 25%
          display: flex
          justify-content: center
          align-items: center
          border: 1px solid #bfbfbf
          border-top: none
          border-right: none
          height: 30px
          &:last-child
           border-right: 1px solid #bfbfbf
    
  .firsttime
    width: 100%
    margin-bottom: 6px
    background: white
    height: 80px
    font-size: 14px
    .firsttimeText
      margin: 6px 0 6px 6px
      padding-top: 6px
      padding-bottom: 6px
    .firsttimeButton
      margin-left: 20px
      width: 200px
      height: 32px
      border: 1px solid #bfbfbf
      display: flex
      justify-content: center
      align-items: center
      border-radius: 6px
      &.on
        background: #009933
        color: white
  .nothing
    height: 42px
  .foot
    width: 100%
    height: 40px
    position: fixed
    left: 0
    right: 0
    bottom: 0
    display: flex
    .confirm
      width: 70%
      height: 100%
      background: #c21a1a
      text-align: center
      line-height: 40px
      color: white
    .kf
      width: 30%
      height: 100%
      background: #009933
      text-align: center
      line-height: 40px
      color: white
      & a
        color white
        display: inline-block
        width 100%
        height 100%
        display flex
        align-items center
        justify-content center

    
</style>



// WEBPACK FOOTER //
// src/pages/OrderEdit/PeriodicOrderEdit.vue